import React, { Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { Spin } from '@pepper/ui'

import Activities from './TabContent/Activities/Activities'
import AssignmentBrief from './TabContent/AssignmentBrief/AssignmentBrief'
import Content from './TabContent/Content/Content'
import LinkedItems from './TabContent/LinkedItems'
import { FieldKeys } from './AssignmentDetails'

type Props = {
  projectBrief: FieldKeys[]
  assignmentBrief: FieldKeys[]
  projectFormFields: BackendFormField[]
  id: string
  data: Assignment
  refetch: () => void
  callBacks?: {
    setTotalRecentActivity: (value: number) => void
  }
}

const AssignmentDetailsRouter: React.FC<Props> = ({
  id,
  data,
  refetch,
  callBacks,
  projectBrief,
  assignmentBrief,
  projectFormFields,
}) => {
  const rootUrl = `/assignment/${id}`
  const routes = [
    {
      path: `${rootUrl}/brief`,
      component: (
        <AssignmentBrief
          data={data}
          projectBrief={projectBrief}
          assignmentBrief={assignmentBrief}
        />
      ),
      exact: true,
    },

    {
      path: `${rootUrl}/linked-items`,
      component: data?.group_id ? (
        <LinkedItems
          groupId={data.group_id}
          assignmentId={data.id}
          projectId={data.project.id}
          isPage={true}
        />
      ) : null,
      exact: true,
    },
    {
      path: `${rootUrl}/activities`,
      component: (
        <Activities
          projectFormFields={projectFormFields}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          assignmentBrief={assignmentBrief as any[]}
          id={id}
          data={data}
          refetch={refetch}
          callBacks={callBacks}
          keepSamePage={false}
        />
      ),
      exact: true,
    },
    {
      path: `${rootUrl}/content`,
      component: (
        <Content
          data={data}
          assignmentId={id}
          projectBrief={projectBrief}
          assignmentBrief={assignmentBrief}
        />
      ),
      exact: true,
    },
  ]

  return (
    <Suspense fallback={<Spin />}>
      <Switch>
        {routes.map((route, idx) => (
          <Route exact={route.exact} key={idx} path={route.path}>
            {route.component}
          </Route>
        ))}
        <Redirect to={routes[2].path} />
      </Switch>
    </Suspense>
  )
}

export default AssignmentDetailsRouter
